import {
  Typography,
} from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BodyTypography } from '../shared/Styles';

export function VisualizerDescription() {
  return (
    <>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        <FormattedMessage id="visualizer-description.header" />
      </Typography>
      <BodyTypography variant="body1" gutterBottom>
        <FormattedMessage id="visualizer-description.p1" />
      </BodyTypography>
      <BodyTypography variant="body1" gutterBottom>
        <FormattedMessage id="visualizer-description.p2" />
      </BodyTypography>
    </>
  );
}
